import {
  GET_CLIENT_CHECKINS,
  GET_CLIENT_CHECKINS_SUCCESS,
  GET_CLIENT_CHECKINS_ERROR,
  COMMENT_CHECKIN,
  COMMENT_CHECKIN_SUCCESS,
  COMMENT_CHECKIN_ERROR,
  MARK_CHECKIN_REVIEWED,
  MARK_CHECKIN_REVIEWED_SUCCESS,
  MARK_CHECKIN_REVIEWED_ERROR,
  GET_CURRENT_CHECKIN,
  GET_CURRENT_CHECKIN_SUCCESS,
  GET_CURRENT_CHECKIN_ERROR,
  SUBMIT_CHECKIN,
  SUBMIT_CHECKIN_SUCCESS,
  SUBMIT_CHECKIN_ERROR,
  RESET_SUBMIT_CHECKIN,
  GET_MY_CHECKINS,
  GET_MY_CHECKINS_SUCCESS,
  GET_MY_CHECKINS_ERROR,
} from './constants';

export function getClientCheckIns(clientId, limit = 12) {
  return { type: GET_CLIENT_CHECKINS, clientId, limit };
}
export function getClientCheckInsSuccess(payload) {
  return { type: GET_CLIENT_CHECKINS_SUCCESS, payload };
}
export function getClientCheckInsError(err) {
  return { type: GET_CLIENT_CHECKINS_ERROR, err };
}

// `aiDraftText` is the verbatim AI-drafted reply the trainer started
// from (if any). Forwarded to the server so the (draft, sent) pair can
// be logged for prompt-quality feedback — the trainer's final text may
// be the draft as-is, an edited version, or a complete rewrite. The
// edit distance between the two is the signal we want over time.
export function commentCheckIn(checkInId, comment, aiDraftText) {
  return { type: COMMENT_CHECKIN, checkInId, comment, aiDraftText };
}
export function commentCheckInSuccess(payload) {
  return { type: COMMENT_CHECKIN_SUCCESS, payload };
}
export function commentCheckInError(err) {
  return { type: COMMENT_CHECKIN_ERROR, err };
}

/** Mark a check-in reviewed with no comment (clears the review queue flag). */
export function markCheckInReviewed(checkInId) {
  return { type: MARK_CHECKIN_REVIEWED, checkInId };
}
export function markCheckInReviewedSuccess(payload) {
  return { type: MARK_CHECKIN_REVIEWED_SUCCESS, payload };
}
export function markCheckInReviewedError(err) {
  return { type: MARK_CHECKIN_REVIEWED_ERROR, err };
}

/** Fetch the requesting client's check-in for the current ISO week. */
export function getCurrentCheckIn() {
  return { type: GET_CURRENT_CHECKIN };
}
export function getCurrentCheckInSuccess(payload) {
  return { type: GET_CURRENT_CHECKIN_SUCCESS, payload };
}
export function getCurrentCheckInError(err) {
  return { type: GET_CURRENT_CHECKIN_ERROR, err };
}

/**
 * Client-side submit. Payload shape mirrors the server fields exactly:
 *   { energy, sleep, sleepHours, soreness, hunger, mood, stress,
 *     notes, focusNextWeek, weight: {kg, lb}, photos: {front, side, back} }
 */
export function submitCheckIn(payload) {
  return { type: SUBMIT_CHECKIN, payload };
}
export function submitCheckInSuccess(payload) {
  return { type: SUBMIT_CHECKIN_SUCCESS, payload };
}
export function submitCheckInError(err) {
  return { type: SUBMIT_CHECKIN_ERROR, err };
}
export function resetSubmitCheckIn() {
  return { type: RESET_SUBMIT_CHECKIN };
}

/** Fetch the requesting client's own check-in history (web parity with mobile). */
export function getMyCheckIns(limit = 12) {
  return { type: GET_MY_CHECKINS, limit };
}
export function getMyCheckInsSuccess(payload) {
  return { type: GET_MY_CHECKINS_SUCCESS, payload };
}
export function getMyCheckInsError(err) {
  return { type: GET_MY_CHECKINS_ERROR, err };
}
